<div class="container-akana-loading">
  <div class="akana-gif">
    <img width="274px" src="./assets/global-position/loading_akana.gif" alt="">
  </div>
</div>
